import confluenceIcon from '~/assets/logo/confluence.svg?react'
import googleDriveIcon from '~/assets/logo/google-drive.svg?react'
import notionIcon from '~/assets/logo/notion.svg?react'

export const LogoIcons = {
  googleDriveIcon,
  notionIcon,
  confluenceIcon,
} as const
